import React from "react";

export function Badge({ children, className = "", variant = "default" }) {
  const baseStyle = "px-2 py-1 rounded-full text-xs font-medium";
  const variants = {
    default: "bg-secondary text-white",
    primary: "bg-primary text-white",
    accent: "bg-accent text-textPrimary",
    outline: "border border-secondary text-secondary",
  };

  return (
    <span className={`${baseStyle} ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
}
